export const colorScaleTable = [
  "#DADEE6", // color of Headers
  "#ECF0F8", // color of subHeaders
  "#f9f9f9",
  "#f9f9f9",
  "#e2f8fb",
  "#F1F8FF",
  "#E8F3FF",
  "#DDEEFF", // color of Level 8
];
export const tableTooltipProps = {
  tooltip: {
    sx: {
      backgroundColor: "#1D5083",
      color: "#fff",
      padding: "10px 14px",
      borderRadius: "8px",
      border: "1px solid #fff",
      fontSize: "16px",
      textContent: "center",
      maxWidth: "150px",
      lineHeight: "1.5",
      transition: "opacity 0.5s ease-in-out",
    },
  },
};

export const getColor = (level: number) => colorScaleTable[level - 1] || "#f9f9f9";
